import React from "react";

const Button = ({
  type = "button",
  text,
  onClick,
  variant = "default", // 'default', 'login', etc.
  icon, // icon component before text
  iconEnd, // icon component after text
  loading = false,
  disabled = false,
  className = "",
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      className={`flex rounded-xl items-center justify-center gap-2 px-4 py-2  font-semibold transition-all duration-200
  ${
    variant === "login"
      ? "bg-transparent border-[1.4px] text-[#00504E] border-[#0d504f] hover:!bg-[#00504f09] hover:!text-slate-700 *:hover:!border-[#00504f09]"
      : "bg-[#00504E] text-white hover:bg-[#003836]"
  }
  ${disabled || loading ? "opacity-50 cursor-not-allowed" : ""}
  ${className}`}
    >
      {loading && (
        <svg className="w-5 h-5 text-white animate-spin" viewBox="0 0 24 24">
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
            fill="none"
          />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
          />
        </svg>
      )}
      {!loading && icon && <span>{icon}</span>}
      <span>{text}</span>
      {!loading && iconEnd && <span>{iconEnd}</span>}
    </button>
  );
};

export default Button;
